import fonts from '../fonts';
import { normalizeFontFamilyName } from '../normalize-font-family-name';
export var getFontFallback = function (name) {
    var normalizedName = normalizeFontFamilyName(name);
    var font = fonts.find(function (_a) {
        var normalizedDisplayName = _a.normalizedDisplayName, normalizedFontFamily = _a.normalizedFontFamily;
        return [normalizedFontFamily, normalizedDisplayName].includes(normalizedName);
    });
    return font ? font.fallbacks : '';
};
//# sourceMappingURL=get-font-fallback.js.map